// extracted by mini-css-extract-plugin
export default {"container":"outsideAppLoader_container__PXQTI","message":"outsideAppLoader_message__Wyjx1"};